/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import {
    CashboxesByTaxNumbersItemDto,
    COMPANIES_STATUSES,
    CompanyDetailsDto,
    CompanyDto,
    CompanyStore,
} from './companiesClient.typings';
import { factoryT, factoryTBuilder, fields } from 'factory-t';
import { legalAddressFactory } from '../operators/operatorsFactories';
import {
    AiActivitiesType,
    AiClassificationHistoryItemDto,
    Currency,
    RegistryTurnoversByObject,
} from '../apiCommon.typings';
import { ServiceOperatorDto, STORE_STATUSES, StoreType } from '../stores/storesClientTypings';
import { turnoversPartialDtoFactory } from '../statistics/statisticsFactories';

export const companyDtoFactory = factoryTBuilder<CompanyDto>({
    taxNumber: (ctx) => `020000071${ctx.index}`,
    name: fields.string(),
    storeTypes: [StoreType.ADVERTISING, StoreType.BANK, StoreType.BEAUTY, StoreType.CAFE, StoreType.CAR_SERVICE],
    storesCount: 19,
    cashBoxes: {
        total: 11,
        count: 11,
        online: 2,
        offline: 9,
        registration: 4,
        blocked: 1,
    },
    status: fields.sequence(Object.values(COMPANIES_STATUSES)),
    taxAuthority: (ctx) => `${ctx.index} saylı Ərazi Vergilər İdarəsi`,
    taxationTypes: ['VAT', 'INCOME', 'PROFIT', 'SIMPLIFIED'],
})
    .setFieldFactory('name', (ctx) => `Company ${ctx.inject('taxNumber')}`)
    .factory();

export const serviceOperatorsFactory = factoryT<ServiceOperatorDto>({
    name: (ctx) => `Random${ctx.index}Corparated`,
    taxNumber: (ctx) => `1945872000${ctx.index}`,
});

export const companyDetailsFactory = factoryT<CompanyDetailsDto>({
    taxNumber: (ctx) => `02000007${ctx.index}`,
    name: 'Random13Corparated',
    activity: ['CULTURAL', 'TRANSPORTATION'],
    stores_count: null,
    legal_address: legalAddressFactory.item(),
    fullAddress: 'Region11 Locale1 City5region11 Street1city84 building 1',
    registration_date: `${new Date().toISOString()}`,
    serviceOperators: serviceOperatorsFactory.list({ count: 2 }),
    status: 'ACTIVE',
    taxAuthority: 'Tax authority-222',
    taxationTypes: ['VAT', 'INCOME', 'PROFIT', 'SIMPLIFIED'],
    taxpayerType: 'PHYSICAL',
    classification: AiActivitiesType.JEWELRY_ACCESSORIES,
    classificationProbability: 50,
});

export const companyStoreFactory = factoryT<CompanyStore>({
    tax_number: (ctx) => `9888${ctx.index}`,
    name: (ctx) => `Store # ${ctx.index}`,
    address: legalAddressFactory.item(),
    fullAddress: 'Region11 Locale1 City5region11 Street1city84 building 1',
    activity: fields.sequence(['CULTURAL', 'TRANSPORTATION']),
    cashboxes: {
        total: 11,
        count: 10,
        online: 6,
        offline: 4,
        invalid_time: 3,
    },
    status: fields.sequence(Object.values(STORE_STATUSES)),
});

export const turnoversByObjectFactory = factoryT<RegistryTurnoversByObject>({
    taxNumber: (ctx) => `${2035620000 + ctx.index}`,
    name: (ctx) => `Store #765432200067500${ctx.index} name`,
    ...turnoversPartialDtoFactory.item(),
    currency: Currency.AZN,
    vatSum: 20390,
    turnover: 4000000,
});

export const cashboxesByTaxNumbersItemFactory = factoryT<CashboxesByTaxNumbersItemDto>({
    taxNumber: (ctx) => `32523${ctx.index}`,
    status: fields.sequence(['REGISTRATION', 'ACTIVE', 'BLOCKED', 'RESET', 'BROKEN', 'SERVICE', 'ELIMINATED']),
    temporary: fields.sequence([false, false, true]),
    storeTaxNumber: (ctx) => `3235235235${ctx.index}`,
    storeName: (ctx) => `store_name_${ctx.index}`,
    companyTaxNumber: (ctx) => `56756756756${ctx.index}`,
    companyName: (ctx) => `company_name_${ctx.index}`,
    cashRegisterFactoryNumber: (ctx) => `11122234234234234234234234234${ctx.index}`,
    deviceFactoryNumber: (ctx) => `345353${ctx.index}`,
});

export const aiClassificationsHistoryItemFactory = factoryT<AiClassificationHistoryItemDto>({
    insertedDateAtUtc: '2023-04-08T17:19:42.097694',
    startDateAtUtc: '2023-01-08T15:19:42.097694',
    endDateAtUtc: '2023-04-08T15:19:42.097694',
    classification: fields.sequence([
        AiActivitiesType.TOYS_BOOKS_GAMES_STATIONERY,
        AiActivitiesType.ALL_TYPES,
        AiActivitiesType.COOKEDFOOD,
        AiActivitiesType.PHARMACY_OPTICS,
    ]),
    classificationProbability: fields.sequence([85, 35, 25, 95]),
});
